import cx from 'classnames';
import React, { RefObject } from 'react';

import styles from './CustomDot.scss';

interface CustomDotProps {
  title?: string;
  className?: string;
  handleSliding: (index: number) => void;
  slideIndex: number;
  currentSlideIndex: number;
  ULRef?: RefObject<HTMLUListElement>;
  makeTabsPanelSliding: boolean;
}

function getElementWidth(element: Element): number {
  return element.clientWidth;
}

function getAllPreviousSiblingsWidth(currentSlideIndex: number, ULChildren: HTMLCollection): number {
  if (currentSlideIndex === 0) return 0;
  return Array.from(ULChildren)
    .slice(0, currentSlideIndex)
    .map(element => getElementWidth(element))
    .reduce((sum, width) => sum + width);
}

class CustomDot extends React.PureComponent<CustomDotProps> {
  componentDidUpdate(prevProps: CustomDotProps) {
    const { currentSlideIndex: previousSlidingIndex } = prevProps;
    const { currentSlideIndex, slideIndex, ULRef, makeTabsPanelSliding } = this.props;

    if (makeTabsPanelSliding || !ULRef || !ULRef.current) return;

    if (currentSlideIndex !== previousSlidingIndex && currentSlideIndex === slideIndex) {
      const previousSiblingsWidth = getAllPreviousSiblingsWidth(currentSlideIndex, ULRef.current.children);
      const currentElementWidth = getElementWidth(ULRef.current.children[currentSlideIndex]);

      ULRef.current.style.left = `calc(50vw - ${previousSiblingsWidth + currentElementWidth / 2}px)`;
    }
  }

  render() {
    const { title, slideIndex, handleSliding, currentSlideIndex = 0 } = this.props;

    if (!title) return null;

    return (
      <button
        onClick={() => handleSliding(slideIndex)}
        className={cx(styles.dot, {
          [styles.dotActive]: slideIndex === currentSlideIndex,
          [styles.dotInactive]: slideIndex !== currentSlideIndex,
        })}
      >
        {title}
      </button>
    );
  }
}

export {
  CustomDot,
  getElementWidth,
  getAllPreviousSiblingsWidth,
};
